import React from 'react';
import { Link } from 'react-router-dom';
import { PlaneIcon, ShieldCheckIcon, LockIcon, PhoneIcon } from 'lucide-react';
import { ROUTES } from '../../constants/routes';
export function Footer() {
  return <footer className="bg-surface-900 text-white" data-id="element-265">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-266">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-267">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-268">
            <Link to={ROUTES.HOME} className="flex items-center gap-2 mb-4" data-id="element-269">
              <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center" data-id="element-270">
                <PlaneIcon className="w-5 h-5 text-white" data-id="element-271" />
              </div>
              <span className="text-heading-md" data-id="element-272">AeroZeep</span>
            </Link>
            <p className="text-body-sm text-surface-400 mb-4" data-id="element-273">
              Nigeria's fastest airline refund platform. Get your money back in
              minutes, not weeks.
            </p>
            <div className="flex items-center gap-4" data-id="element-274">
              <div className="flex items-center gap-1 text-caption text-surface-400" data-id="element-275">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-276" />
                NCAA Compliant
              </div>
              <div className="flex items-center gap-1 text-caption text-surface-400" data-id="element-277">
                <LockIcon className="w-4 h-4" data-id="element-278" />
                NDPR Secure
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-279">
            <h4 className="text-body-md font-semibold mb-4" data-id="element-280">Quick Links</h4>
            <ul className="space-y-2" data-id="element-281">
              <li data-id="element-282">
                <Link to={ROUTES.REFUND} className="text-body-sm text-surface-400 hover:text-white transition-colors" data-id="element-283">
                  Get Refund
                </Link>
              </li>
              <li data-id="element-284">
                <Link to={ROUTES.WALLET} className="text-body-sm text-surface-400 hover:text-white transition-colors" data-id="element-285">
                  My Wallet
                </Link>
              </li>
              <li data-id="element-286">
                <Link to={ROUTES.SEARCH} className="text-body-sm text-surface-400 hover:text-white transition-colors" data-id="element-287">
                  Book Flight
                </Link>
              </li>
              <li data-id="element-288">
                <Link to={ROUTES.HISTORY} className="text-body-sm text-surface-400 hover:text-white transition-colors" data-id="element-289">
                  Transaction History
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-290">
            <h4 className="text-body-md font-semibold mb-4" data-id="element-291">Legal</h4>
            <ul className="space-y-2" data-id="element-292">
              <li data-id="element-293">
                <a href="#" className="text-body-sm text-surface-400 hover:text-white transition-colors" data-id="element-294">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-295">
                <a href="#" className="text-body-sm text-surface-400 hover:text-white transition-colors" data-id="element-296">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-297">
                <a href="#" className="text-body-sm text-surface-400 hover:text-white transition-colors" data-id="element-298">
                  Refund Policy
                </a>
              </li>
              <li data-id="element-299">
                <a href="#" className="text-body-sm text-surface-400 hover:text-white transition-colors" data-id="element-300">
                  NCAA Compliance
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Stakeholders */}
          <div data-id="element-301">
            <h4 className="text-body-md font-semibold mb-4" data-id="element-302">Contact</h4>
            <ul className="space-y-2 mb-6" data-id="element-303">
              <li className="flex items-center gap-2 text-body-sm text-surface-400" data-id="element-304">
                <PhoneIcon className="w-4 h-4" data-id="element-305" />
                +234 800 000 0000
              </li>
              <li className="text-body-sm text-surface-400" data-id="element-306">
                support@aerozeep.com
              </li>
              <li className="text-body-sm text-surface-400" data-id="element-307">Lagos, Nigeria</li>
            </ul>

            {/* Stakeholder Login */}
            <div className="pt-4 border-t border-surface-700" data-id="element-308">
              <Link to={ROUTES.ADMIN_LOGIN} className="inline-flex items-center gap-2 text-body-sm text-surface-400 hover:text-primary-400 transition-colors" data-id="element-309">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-310" />
                Stakeholder Portal
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-surface-700" data-id="element-311">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-312">
            <p className="text-body-sm text-surface-500" data-id="element-313">
              © {new Date().getFullYear()} AeroZeep. All rights reserved.
            </p>
            <div className="flex items-center gap-4 text-body-sm text-surface-500" data-id="element-314">
              <span data-id="element-315">Regulated by NCAA</span>
              <span data-id="element-316">•</span>
              <span data-id="element-317">NDPR Compliant</span>
              <span data-id="element-318">•</span>
              <span data-id="element-319">PCI-DSS Certified</span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}